import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { WorkTask, WorkTaskSearchModel, WorkTaskViewModel } from '../models';

@Injectable()
export class WorkTaskService {

  constructor(private http: HttpClient) { }

  add(task: WorkTask) {
    return this.http.post<WorkTask>('admin/worktask', task);
  }

  delete(id: number) {
    return this.http.delete('admin/worktask/' + id);
  }

  get(id: number) {
    return this.http.get<WorkTask>('admin/worktask/' + id);
  }

  update(task: WorkTask) {
    return this.http.put('admin/worktask', task);
  }

  search(model: WorkTaskSearchModel) {
    return this.http.post<WorkTaskViewModel[]>('admin/worktask/search', model);
  }
}
